import { ChangeEvent } from 'react';
import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PoolTextField, useFilter } from '@synergy/components';
import { getCurrencySymbol } from '@synergy/utils';

import { bestLocaleSelector } from '../../selectors/locale-selectors';
import { useAppSelector } from '../../../store/use-appstate-selector';

export const MaxPriceFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();
    const { currency } = useAppSelector(state => state.settings);
    const locale = useAppSelector(state => bestLocaleSelector(state));
    const currencySymbol = getCurrencySymbol(currency, locale);

    const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const maxPrice: number = +event.target.value;
        filter.delete(FilterParams.MaxPrice);
        if (!isNaN(maxPrice)) {
            filter.set(FilterParams.MaxPrice, maxPrice.toString());
        }
        updateFilter(filter);
    };

    registerFilterMap(FilterParams.MaxPrice, value => `${value} ${currencySymbol}`);

    return (
        <PoolTextField
            fullWidth={true}
            label={<FormattedMessage id="app.label.maxPrice" />}
            value={filter.get(FilterParams.MaxPrice)}
            onChange={handleChange}
            isNumeric={true}
            endAdornment={currencySymbol}
        />
    );
};
